import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import colorPicker from './colorPicker.vue';

@Component({
  components: { colorPicker },
  mixins: [style],
})
export default class TextEdit extends Vue {
  @Prop({ default: () => {} })
    value: DisplayTextData;

  @Prop({ default: false })
    disabled: boolean;

  data: DisplayTextData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="container margin-top-none r-mx-20 r-my-10" key={this.data.sort}>
        <el-form props={{ model: this.data }} label-width="0" ref="form" disabled={this.disabled}>
          <p class="blockTitle center-text-title">标题</p>
          <el-form-item prop={'desc.title'} class="r-mb-0">
            <el-input v-model={this.data.desc.title} show-word-limit maxlength={20}></el-input>
          </el-form-item>
          <el-row class="text-title-size">
            <el-col span={8} class="blockTitle center-text-title">
              标题大小
            </el-col>
            <el-col span={16}>
              <el-radio-group v-model={this.data.desc.titleSize}>
                <el-radio label={28}>小</el-radio>
                <el-radio label={36}>中</el-radio>
                <el-radio label={44}>大</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="text-title-style">
            <el-col span={8} class="blockTitle center-text-title">
              标题样式
            </el-col>
            <el-col span={16}>
              <el-checkbox-group v-model={this.data.desc.titleStyle}>
                <el-checkbox label={'bold'} class="inline-block">
                  加粗
                </el-checkbox>
                <el-checkbox label={'center'} class="inline-block">
                  居中对齐
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row class="text-title-color text-title-style">
            <el-col span={8} class="blockTitle center-text-title">
              标题颜色
            </el-col>
            <el-col span={6}>
              <el-form-item prop={'desc.titleColor'} rules={{ required: true, message: '请设置标题颜色', trigger: ['blur', 'change'] }} class="text-color-picker">
                <colorPicker v-model={this.data.desc.titleColor} disabled={this.disabled} />
              </el-form-item>
            </el-col>
            <el-col span={10} class="r-pt-8">
              {this.data.desc.titleColor}
            </el-col>
          </el-row>
          <div class="text-content">
            <p class="blockTitle center-text-title">文本</p>
            <el-form-item prop={'desc.content'}>
              <el-input type="textarea" placeholder="请输入内容" maxlength="500" show-word-limit v-model={this.data.desc.content} resize="none" autosize={{ minRows: 4, maxRows: 6 }}></el-input>
            </el-form-item>
          </div>
          <el-row class="text-content-size text-title-size">
            <el-col span={8} class="blockTitle center-text-title">
              文本大小
            </el-col>
            <el-col span={16}>
              <el-radio-group v-model={this.data.desc.contentSize}>
                <el-radio label={28}>小</el-radio>
                <el-radio label={36}>中</el-radio>
                <el-radio label={44}>大</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="text-title-style">
            <el-col span={8} class="blockTitle center-text-title">
              文本样式
            </el-col>
            <el-col span={16}>
              <el-checkbox-group v-model={this.data.desc.contentStyle}>
                <el-checkbox label={'bold'} class="inline-block">
                  加粗
                </el-checkbox>
                <el-checkbox label={'center'} class="inline-block">
                  居中对齐
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row class="text-content-color text-title-color text-title-style">
            <el-col span={8} class="blockTitle center-text-title">
              文本颜色
            </el-col>
            <el-col span={6}>
              <el-form-item prop={'desc.contentColor'} rules={{ required: true, message: '请设置内容颜色', trigger: ['blur', 'change'] }} class="text-color-picker">
                <colorPicker v-model={this.data.desc.contentColor} disabled={this.disabled} />
              </el-form-item>
            </el-col>
            <el-col span={10} class="r-pt-8">
              {this.data.desc.contentColor}
            </el-col>
          </el-row>
          <div class="dashed-line"></div>
          {/* <el-row class="text-bg text-title-color text-title-style">
        <el-col span={8} class="blockTitle ">
          区域底色
        </el-col>
        <el-col span={6}>
          <el-color-picker v-model={value.desc.backGround}></el-color-picker>
        </el-col>
        <el-col span={10}>{value.desc.backGround}</el-col>
      </el-row> */}
          <el-row class="text-title-size">
            <el-col span={8} class="blockTitle center-text-title">
              文字边距
            </el-col>
            <el-col span={16}>
              <el-slider step={2} v-model={this.data.desc.margin} style="width: 85%" min={0} max={40}></el-slider>
            </el-col>
          </el-row>
        </el-form>
      </div>
    );
  }
}
